import React from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Input from "react-currency-masked-input";

import { getLocalisationVal, transformInput } from "@/utils/localizationUtil";
import { Colors } from "@/theme";
import useStyles from "./styles";

const ProductCard = ({
  isLast,
  localization,
  product,
  newPrice,
  onChangePrice,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const productPrice = product.prices?.[0]?.gross_price;
  const previousPrice = product.prices?.[0]?.history?.points?.[0]?.gross_price;

  return (
    <Grid
      container
      component={"main"}
      alignItems={"center"}
      sx={{
        padding: "30px 0px",
        borderBottom: `1px solid ${Colors.GRAY_BORDER}`,
      }}
    >
      <Grid item xs={2}>
        <span className={classes.codeText}>{product.product_code}</span>
      </Grid>
      <Grid item xs={3.5}>
        <span className={classes.priceText}>{`${getLocalisationVal(
          localization,
          productPrice
        )}p`}</span>
      </Grid>
      <Grid item xs={3.5}>
        <span className={classes.priceText}>
          {!!previousPrice
            ? `${getLocalisationVal(localization, previousPrice)}p`
            : ""}
        </span>
      </Grid>
      <Grid item xs={3}>
        <Box width={"80%"}>
          <Input
            value={getLocalisationVal(localization, newPrice)}
            onChange={(e, value) =>
              onChangePrice(transformInput(localization, value))
            }
            className={classes.currencyInput}
            type=""
            separator={localization.digit_separator === "," ? "." : ","}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default ProductCard;
